import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import ModalButtons from '../../components/Modal/ModalButtons';
import DeleteModalSkeleton from '../../components/Skeletons/DeleteModalSkeleton';
import TextArea from '../../components/Modal/TextArea';
import SelectBox from '../../components/SelectBoxButton';

const AddVideoNoteModal = ({
  loading,
  handleSubmit,
  show,
  handleModalClose,
  data,
}) => {
  const { t } = useTranslation();
  const { newVideoNote, setNewVideoNote, noteType, setNoteType } = data;

  return (
    <Modal show={show}>
      <ModalHeading heading={t('screens.chat.addVideoNote')} />
      {loading ? (
        <DeleteModalSkeleton />
      ) : (
        <ModalForm style={{ marginBottom: '2.5rem' }}>
          <InputsSection style={{ width: '34rem' }}>
            <TextArea
              placeholder={t('screens.chat.writeNoteHere')}
              rows={5}
              value={newVideoNote.value}
              onChange={(e) =>
                setNewVideoNote({ value: e.target.value, error: '' })
              }
              errorMessage={newVideoNote.error}
            />
            {/* <SelectBox
              // label='Note Type'
              value={noteType.value}
              onChange={(e) =>
                setNoteType({ value: e.target.value, error: '' })
              }
              errorMessage={noteType.error}
            >
              <option value='internal'>Internal Note</option>
              <option value='public'>Shared with user</option>
            </SelectBox> */}

            <SelectBox
              buttons={[
                {
                  label: t('screens.chat.internalNote'),
                  value: 'internal',
                  onClick: () => setNoteType({ value: 'internal', error: '' }),
                },
                {
                  label: t('screens.chat.sharedWithUser'),
                  value: 'public',
                  onClick: () => setNoteType({ value: 'public', error: '' }),
                },
              ]}
              value={noteType.value}
            />

            {/* <div>
              <button
                type='button'
                onClick={() => setNoteType({ value: 'internal', error: '' })}
              >
                Internal Note
              </button>
              <button
                type='button'
                onClick={() => setNoteType({ value: 'public', error: '' })}
              >
                Shared with user
              </button>
            </div> */}
          </InputsSection>

          <ModalButtons
            submitButtonLabel={t('screens.chat.addNote')}
            onSubmit={handleSubmit}
            cancelButtonLabel={t('screens.chat.cancel')}
            onCancel={handleModalClose}
          />
        </ModalForm>
      )}
    </Modal>
  );
};

export default AddVideoNoteModal;
